var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChallenge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a5eb8446-8701-4d28-8866-2ebd5e37e3ba",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .f2577117-d67f-4768-9a19-e0defa48febc {\n        fill: #1d1d1b;\n      }\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vbl") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "f2577117-d67f-4768-9a19-e0defa48febc",
    d: "M109.33,34.76H93.7l-1.52-6.47a5.25,5.25,0,0,0-5.11-4H61.2a5.24,5.24,0,0,0-5.11,4l-1.53,6.47H18.67A4.73,4.73,0,0,0,14,39.47V99.31A4.74,4.74,0,0,0,18.67,104h90.66a4.74,4.74,0,0,0,4.72-4.72V39.47A4.73,4.73,0,0,0,109.33,34.76Zm1.72,64.55a1.75,1.75,0,0,1-1.72,1.72H18.67A1.75,1.75,0,0,1,17,99.31V39.47a1.74,1.74,0,0,1,1.72-1.71H56.93l.55-2.31L59,29a2.24,2.24,0,0,1,2.19-1.73H87.07A2.25,2.25,0,0,1,89.26,29l1.53,6.47.54,2.31h18a1.74,1.74,0,0,1,1.72,1.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f2577117-d67f-4768-9a19-e0defa48febc",
    d: "M74.77,42.64A25.46,25.46,0,1,0,100.23,68.1,25.46,25.46,0,0,0,74.77,42.64Zm0,47.91A22.46,22.46,0,1,1,97.23,68.1,22.48,22.48,0,0,1,74.77,90.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f2577117-d67f-4768-9a19-e0defa48febc",
    d: "M74.77,49.48A18.62,18.62,0,1,0,93.39,68.1,18.62,18.62,0,0,0,74.77,49.48Zm0,34.24A15.62,15.62,0,1,1,90.39,68.1,15.64,15.64,0,0,1,74.77,83.72Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f2577117-d67f-4768-9a19-e0defa48febc",
    cx: 27.62,
    cy: 46.44,
    r: 4.59
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallenge);
export default __webpack_public_path__ + "static/media/challenge.3de9ac12d600b0be57b849e2a325c47f.svg";
export { ForwardRef as ReactComponent };